import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerUpLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowCornerUpLeft"><Path d="M20.5 19.5V9H3.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/><Path d="M8 13.5L3.5 9L8 4.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconArrowCornerUpLeft;
